import { TabBookingAbstract } from './tabBookingAbstract'
import { Company } from '@/class/model/mdm/Company'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { AbstractEntity as WarehouseInfo } from '@/class/model/AbstractEntity'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { TabError } from '@/utils/class/TabError'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { OS_BOOKING_TYPE } from '@/class/cargo/model/parameters/BookingTerm'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { batchRemoveJob, checkJobForShared } from '@/api/seaExport/seaExportJob'
import { syncLclSlaveMasterJob } from '@/api/booking/job'
import { batchAddJob } from '@/api/SeaImport/seaImportJob'
import { getWarehouseDetail } from '@/api/company'
import { ContainerNewUtil } from '@/class/cargo/model/utils/ContainerNewUtil'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'

export class MasterBasicTabHP extends TabBookingAbstract {
  constructor(view) {
    super(view)

    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)

    this.defaultChargeCubage = 0 // 默认计费体积 m³
    this.isWithinCloseAccountDate = false // 关账控制

    /**
     * 是否是小票
     */
    this.lclMasterFlag = true

    this.cutomJobTypeList = [] // 自定义业务类型
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }

  init() {
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1

    this.view.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.view.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1

    this.defaultChargeCubage = Number(this.config.get('ImportChargeCubageMT'))

    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })
  }

  /**
   * @private
   * 新增信息
   */
  async updateModel() {
    const _importJob = this.job
    const isNewInstance = StrUtils.isEmpty(_importJob.uuid)

    _importJob.masterFlag = true
    _importJob.signHBL = true
    _importJob.signMBL = true
    _importJob.booking = true
    if (isNewInstance) {
      _importJob.jobState = 0
    }

    _importJob.opOffice = this.view.$store.getters.currentOfficeId
    _importJob.lob = 'SI'

    if (!this.view.visibleDesignationAgent) {
      _importJob.designationAgent = 0
    }

    if (_importJob.csr === 0) {
      _importJob.csrOffice = 0
      _importJob.csrDepartment = 0
    }
    if (_importJob.dc === 0) {
      _importJob.dcOffice = 0
      _importJob.dcDepartment = 0
    }

    _importJob.cargoType = 'GC' // 货物类型默认普货
    // 保存提单地址
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      ImportConstants.saveBillAddress(this.job)
    }

    this.getWarehouseInfo()

    // 新增主票(集拼类型)或者编辑主票(集拼类型)，更新container信息
    // 海运进口 原cargo使用的是 ContainerNewUtil 相关方法，h5调整后 仍使用ContainerUtil
    if (_importJob.masterFlag && this.view.isEdit && _importJob.containerLoadType === 'CON') {
      //   ContainerNewUtil.adjustContainerUsages(_importJob)
      ContainerNewUtil.refContainersNo(_importJob)
    }
  }

  /**
   * @public
   * 输入验证
   */
  async checkModel() {
    const form = this.job
    if (this.view.visibleDesignationAgent && this.job.designationAgent < 1) {
      throw new TabError(this.view.$t('SeaExport.checkNominatedAgent'), 'masterBasicTab')
    }

    if (!form.loadingPortCode) {
      this.view.$nextTick(() => {
        this.view.$refs.loadingPortCode.$refs.advanceSelectRef.focus()
      })
      throw new TabError(this.view.$t('SeaExport.checkLoadingPort2'), 'masterBasicTab')
    }

    if (!form.dischargingPortCode) {
      throw new TabError(this.view.$t('SeaExport.checkPortOfDischarge'), 'masterBasicTab')
    }

    if (!form.destinationPortCode) {
      throw new TabError(this.view.$t('Message.PlaceOfDeliveryCannotBeNull'), 'masterBasicTab')
    }

    // if (!form.destinationPlace) {
    //   throw new TabError(this.view.$t('SeaExport.checkFinalDestination'), 'masterBasicTab')
    // }

    if (!(this.view.viewSource === 'bookingWorkspace' && this.view.$store.state.uiCustom.enable) && !form.etd) {
      throw new TabError(this.view.$t('SeaExport.DateOfDeparture') + this.view.$t('queryJob.CannotBeEmpty'), 'masterBasicTab')
    }

    if (!form.eta) {
      throw new TabError(this.view.$t('SeaExport.DateOfArrival') + this.view.$t('queryJob.CannotBeEmpty'), 'masterBasicTab')
    }
    if (form.etd && form.eta && form.eta < form.etd) {
      throw new TabError(this.view.$t('SeaExport.checkDateOfDepartureAndDateOfArrival'), 'masterBasicTab')
    }

    // 日期格式验证
    /* if (view.dfCustDate.selectedDate != null || view.dfCustDate.text != "")
      {
        if (!ImportConstants.getInstance().validateDate(view.dfCustDate,ResourceManager.getInstance().getString("SeaExport","BillExchangeDate")))
        {
          return false;
        }
      }*/

    // if (form.cargoSource === 'SC' || parseInt(this.config.get('NorminationJobSaleType')) === 1) {
    //   if (!form.sales || form.sales === 0) {
    //     throw new TabError(this.view.$t('SeaExport.checkSales'), 'masterBasicTab')
    //   }
    // } else {
    //   if (form.sales && !form.salesDepartment) {
    //     throw new TabError(this.view.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'masterBasicTab')
    //   }
    // }
    if (!form.opOffice) {
      throw new TabError(this.view.$t('SeaExport.checkDept'), 'masterBasicTab')
    }

    if (form.bookingAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.BillExchangeAgent'), form.bookingAgent, 'masterBasicTab')
    }
    if (form.destinationAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.PortOfLoadingAgent'), form.destinationAgent, 'masterBasicTab')
    }

    if (form.cargoSource === 'NC' && !form.designationAgent) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.NominatedAgent'), form.destinationAgent, 'masterBasicTab')
    }

    if (form.customsBroker) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.CustomsBroker'), form.customsBroker, 'masterBasicTab')
    }
    if (form.warehouseCmp) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.Warehouse'), form.warehouseCmp, 'masterBasicTab')
    }
    if (form.carrierId) {
      await SecurityUtil.companyisActive(this.view.$t('SeaExport.ShippingCompany'), form.carrierId, 'masterBasicTab')
    }
    if (form.customerId > 0 && !SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
      throw new TabError(this.view.$t('CargoMsg.Cargo_CustomerNotOwn'), 'masterBasicTab')
    }
    await JobUtils.checkCustomerBranchScope(form, 'masterBasicTab')
    return true
  }
  /**
   * 更新页面显示
   */
  updateView() {
    if (this.job.cargoSource === null || this.job.cargoSource === 'NC') {
      this.view.visibleDesignationAgent = true
    } else {
      this.view.visibleDesignationAgent = false
    }

    this.view.isTwoVessel = this.job.secondVessel != null && this.job.secondVessel !== ''

    const model = this.job
    const isNewInstance = StrUtils.isEmpty(model.uuid)
    if (isNewInstance) {
      if (model.containerLoadType === 'LCL') {
        model.freightTermHBL = 'CFS-CFS'
        model.trans = true
      } else {
        model.freightTermHBL = 'CY-CY'
      }
      model.incoTerm = ''

      // cargo 控件自动默认第一个下来数据 ，h5手工处理
      if (!model.bookingTerm) {
        model.bookingTerm = OS_BOOKING_TYPE.code
      }
      if (!model.freightTermMBL) {
        const list = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
        if (list && list.length > 0) {
          model.freightTermMBL = list[0].code
        }
      }
      JobUtils.matchUserPortConfig(this.view, model)
      JobUtils.matchRegionWarehouseMappingConfig(model, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, null, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, model, false, null, { keepOriginValue: true })
    }
    this.view.controllerEnable.qCargoType = this.lclMasterFlag || isNewInstance
    this.view.controllerEnable.dfETD = (!model.transDate) && this.view.isEdit
    this.view.controllerEnable.txtCustomerId = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'customerId')
    this.view.controllerEnable.txtDesignationAgent = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'designationAgent')
    this.view.controllerEnable.txtBookingAgent = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'bookingAgent')
    this.view.controllerEnable.txtCarrierId = this.view.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(model, 'carrierId')
    this.view.controllerEnable.txtChargeWeight = this.view.isEdit && SecurityUtil.checkOffsetChargeMeasure(model, 'WGTX')

    // 查询收发通信息
    // todo ImportConstants.getInstance().queryBillAddressHandler(model, 'SI', view.shipperLine2, view.shipperLine3, view.shipperLine4, view.shipperLine5, view.shipperLine6, view.consigneeLine2, view.consigneeLine3, view.consigneeLine4, view.consigneeLine5, view.consigneeLine6, view.notifyLine2, view.notifyLine3, view.notifyLine4, view.notifyLine5, view.notifyLine6)

    this.loadCompanyOffice()
    this.loadWarehouseInfo()

    this.refreshTotals()
    //    CARGO-2880关账控制：关账后，基本页面里的销售公司、销售员、操作部门不允许修改
    this.loadIsWithinClosingAccountDate()
    if (model && isNewInstance) {
      this.selectDefaultCutomJobType()
      // 复制业务时校验新业务岗位角色在当前分公司是否有对应的岗位权限
      if (this.view.action === 'copy') {
        if (model.csr > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.csr.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, model.csr)) {
                model.csr = 0
                model.csrDepartment = 0
              }
            })
          })
        }
        if (model.dc > 0) {
          this.view.$nextTick(() => {
            this.view.$refs.dc.executeAfterLoad(data => {
              if (JobUtils.checkUserRolePrivilege(data, model.dc)) {
                model.dc = 0
                model.dcDepartment = 0
              }
            })
          })
        }
      }
    }
    this.sopConfig()

    // 海运进口 原cargo使用的是 ContainerNewUtil 相关方法，h5调整后 仍使用ContainerUtil
    ContainerUtil.refreshContainerSeaEQ(this.job)
    this.loadWarehouseRegion(false)
  }
  /**
   * 加载job仓库信息
   */
  loadWarehouseInfo() {
    if (this.job === null) { return }

    this.loadWarehouseInfo2Handler()
  }
  loadWarehouseInfo2Handler() {
    if (this.job.warehouseInfo != null && this.job.warehouseInfo.length > 0) {
      this.job.warehouseCmp = this.job.warehouseInfo[0].warehouseCmp
    } else {
      this.job.warehouseCmp = 0
    }
  }
  async sopConfig() {
    this.view.sopImageA = false
    this.view.sopImageB = false
    this.view.sopImageC = false

    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }
  configSuccessHandler(data) {
    if (data) {
      const sop = data
      if (sop) {
        this.view.sopConfigOpen = sop.ifAuto

        let open = false
        const destinationAgent = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.job.destinationAgent))
        if (destinationAgent !== null && destinationAgent.ifOpenSop && this.view.sopConfigOpen) {
          open = true
        }
        this.view.sopImageB = open
      }
    }
  }

  loadCompanyOffice() {
    const job = this.job
    if (job.salesOffice > 0) {
      const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', job.salesOffice)
      if (office) {
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        this.view.txtSalesOffice = ''
      }
    }
  }
  /**
   * 统计件毛体总和
   */
  refreshTotals() {
    let quantity = 0
    let weight = 0
    let cubage = 0
    let chargeWeight = 0
    if (this.job && this.job.lclSlaves) {
      if (this.job.lclSlaves.length > 0) {
        for (const j of this.job.lclSlaves) {
          quantity += j.quantityContract
          weight += j.weightContract
          cubage += j.cubageContract
          chargeWeight += j.chargeWeight
        }
        this.job.quantityContract = Number(quantity.toFixed(0))
        this.job.cubageContract = Number(cubage.toFixed(3))
        this.job.weightContract = Number(weight.toFixed(2))

        if (parseInt(this.config.get('SIChargeWeightCalculateType')) === 1) {
          this.job.chargeWeight = Number(chargeWeight.toFixed(3))
        }
      }
    }
    this.view.lbTotal.lblTotalWeight = weight.toFixed(3)
    this.view.lbTotal.lblTotalCubage = cubage.toFixed(3)
    this.view.lbTotal.lblTotalQuantity = quantity.toFixed(0)
  }

  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })
    const options = this.cutomJobTypeList.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  loadIsWithinClosingAccountDate() {
    ClosingAccount.isContainClosedCharge(this.context.office.officeId, this.job.jobNo).then(res => {
      this.isWithinCloseAccountDate = Boolean(res.data)
    })
  }

  /**
   * 当选择销售人员的时候自动关联该销售所在分公司
   */
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          const office = await Office.getOfficeByUuid(department.officeUuid)
          job.salesOffice = office.officeId
          job.salesDepartment = department.departmentId
          this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
        }
      }
    }
    this.dipatchChangedSalesEvent(data.userId || 0)
  }
  /**
   * 手动选择销售
   */
  dipatchChangedSalesEvent(sales) {
    // var salesEvent: CommonFormEvent = new CommonFormEvent('salesChanged')
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  /**
   * 按业务指定销售
   */
  async loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      } else {
        this.job.salesOffice = 0
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
      }
    }
  }
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
    }

    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              csrList.push(user)
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            }
          }
        }
      }
    }

    // 自揽货时进行销售变更;指定货以指定货代理为准
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      // 销售
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.view.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          if (user) {
            this.salesChangeHandler({ ...user, value: user.userId })
          }
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 客服
    if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        if (user) {
          this.csrChangeHandler({ ...user, value: user.userId })
        }
      })
    } else {
      job.csr = 0
      job.csrDepartment = 0
    }

    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        if (user) {
          this.cargoSalesChargeHandler({ ...user, value: user.userId })
        }
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.opChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          OverseaCustomerUtils.overseaOpChangeHandler(this.view, { ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
  }

  getTxtSalesPrompt() {
    if ((Number(this.config.get('IsSpecifiedSalesBusiness')) === 1) && (this.view.$refs.sales.options.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  sopChangeCustomerIdHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  /**
   * 销售部门修改后，调整分公司信息
   */
  departmentChargeHandler(event = null) {
    /* if (view.txtSalesDepartment.department && view.txtSalesDepartment.department.office) {
      var officeId:int = view.txtSalesDepartment.department.office.officeId;
      if (officeId != view.job.salesOffice) {
        this.view.txtSalesOffice = ''
        view.job.salesDepartment = view.txtSalesDepartment.departmentId;
        view.job.salesOffice = officeId;
        this.loadCompanyOffice()
      }
    }*/
  }

  /**
   * 操作分公司选择
   */
  opOfficeChangeHandler(event) {
    // todo 下拉框数据源已经实现了动态加载过程，所以下面的代码屏蔽掉即可
    // job.opOffice = view.ddlOpOffice.opOfficeId
    // view.txtOP.queryUser('role', 'op', null, view.ddlOpOffice.opOffice)
    // view.txtDc.queryUser('role', 'doc', null, view.ddlOpOffice.opOffice)
    // if (isEntrustOrder || job.salesOffice == 1) {
    //   view.txtCSR.queryUser('role', 'csr', null, view.ddlOpOffice.opOffice)
    //   //				view.txtOverseaOp.queryUser('role','overseaOp',null,view.ddlOpOffice.opOffice)	// 海外代理
    // }
    JobUtils.opOfficeChange({ view: this.view, job: this.job, warehouseCallback: warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }) })
  }

  /**
   * 操作改变
   */
  opChangeHandler(user) {
    const job = this.job
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        new User(user).getUserDefaultDepartmentByOffice('role', 'siop', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        new User(user).getDefaultDepartment('role', 'siop', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        const office = await Office.getOfficeByUuid(dep.officeUuid)
        job.csrDepartment = dep.departmentId
        job.csrOffice = office.officeId
      }
    }
  }

  /**
   * 单证改变
   */
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.csrOffice = office ? office.officeId : 0
            job.csrDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }

  getDefaultOverseaOpResult(event) {
    // var dep: Department = event.result as Department
    // if (dep)
    //   job.overseaOpDepartment = dep.departmentId
    // else
    //   job.overseaOpDepartment = 0
  }

  /**
   * 航线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'seaLine', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.plannerDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'seaLine')
        job.plannerDepartment = dep ? dep.departmentId : 0
      }
    } else {
      job.planner = 0
      job.plannerDepartment = 0
    }
  }

  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value
    job.warehouseInfo = job.warehouseInfo || []
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    this.view.warehouseNameList = []
    if (job.warehouseCmp > 0) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', job.warehouseCmp)
      if (companyCache) {
        getWarehouseDetail(companyCache.uuid).then(res => {
          if (res.data.length > 0) {
            this.view.warehouseNameList = res.data
          }
        })
      }
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp > 0) {
      job.warehouseName = warehouse.warehouseName
    } else {
      job.warehouseName = ''
    }
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
      const index = modifiedData.warehouseInfo.indexOf(warehouse)
      if (index > -1) {
        modifiedData.warehouseInfo.splice(index, 1)
      }
    }
  }

  sopChangeBookingAgentHandler(event) {
    // if (view.isEditing) {
    //   return
    // }
    // if (job.designationAgent == 0 || (view != null && view.txtDesignationAgent != null && view.txtDesignationAgent.selectedItem == null)) {
    //   MessageDialog.info('请选择指定货代理!')
    //   return
    // }
    // if (job.key == null) {
    //   return
    // }
    // var company: Company = view.txtDesignationAgent.selectedItem as Company
    // SopEmailReceiver.queryJobSopReceiver(job.key, company.cmpIdx, SopConstants.DESIGNATION_AGENT2.code, pageAResultHandler, faultHandler)
  }

  txtDestinationAgentChangeHandler(data) {
    const job = this.job
    this.view.sopImageB = false

    job.destinationAgent = data.value

    this.view.sopImageB = false
    const company = this.companyList.find(p => p.cmpIdx === data.value)
    if (company) {
      if (this.view.sopConfigOpen) {
        this.view.sopImageB = company.ifOpenSop
      }
    }
    OverseaCustomerUtils.destinationAgentChangeHandler(this.view)
  }

  /**
   * 指定货代理 “选择指定货”性质，
   * 销售栏自动取系统内相应海外代理
   * “网管”的名字
   */
  designationAgentChangeHandler(data) {
    const job = this.job
    job.designationAgent = data.value

    ImportConstants.designationAgentWithSalesHandler(job.designationAgent, this.job, this.view.salesOfficeCheck, this.view.$refs.sales.options)
    OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this.view)
  }

  destinationPortCodeEasyChange(data) {
    // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
    if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = data.englishName
    }
  }

  /**
   * 揽货类型选择 cargoSource_Change
   */
  async cargoSourceChange(value) {
    if (value === CargoSource.SC_CARGO_SOURCE.code) {
      this.view.visibleDesignationAgent = false
    } else {
      this.view.visibleDesignationAgent = true
    }
    OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this.view)
    JobUtils.matchUserPortConfig(this.view, this.job)
  }

  /**
   * 卸货港选择
   */
  async dischargingPortCode_Change(evt) {
    const job = this.job
    if (Number(this.config.get('SyncPOD')) === 1) {
      job.destinationPortCode = job.dischargingPortCode
    } else {
      job.destinationPortCode = job.destinationPortCode || job.dischargingPortCode
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const selPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
    if (selPort && selPort.length > 0) {
      if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
        job.destinationPlace = selPort[0].englishName
      }
    }
    await this.loadWarehouseRegion(true)
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job)
  }
  /**
   * 根据提单号获取船名航次
   */
  getMblVesselEqEvent() {
    if (StrUtils.isEmpty(this.job.vessel) || StrUtils.isEmpty(this.job.voyageFlight)) {
      this.view.$message.show(this.view.$t('SeaExport.checkVslVoy'))
    }
    // 此功能不要了 SeaImportJob.getEtaAccordingToVesselVoyage(view.txtVessel.text, view.txtVoyage.text.replace("V.",""), new mx.rpc.Responder(getMblVesselVoyageResult, onFailed));
  }

  /**
   * 单号抄录
   */
  onExcerption() {
    this.view.importPromptTitleDialog.visible = true
  }

  /**
   * 单号抄录
   */
  async onExcerptionChangeFunc(data) {
    this.job.shipperCode = data.shipperCode
    this.job.shipperLine1 = data.shipperLine1
    this.job.consigneeCode = data.consigneeCode
    this.job.consigneeLine1 = data.consigneeLine1
    this.job.notifyCode = data.notifyCode
    this.job.notifyLine1 = data.notifyLine1

    const hDoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hDoc) {
      hDoc.shipperCode = this.job.shipperCode
      hDoc.shipperLine1 = this.job.shipperLine1
      hDoc.consigneeCode = this.job.consigneeCode
      hDoc.consigneeLine1 = this.job.consigneeLine1
      hDoc.notifyCode = this.job.notifyCode
      hDoc.notifyLine1 = this.job.notifyLine1
    }
  }
  /**
   * @public
   * 代码检索
   */
  onCodeSearch() {
    this.view.billAddressDialog.visible = true
  }

  codeSearchCallback(data) {
    let billAddress = null
    if (data.shipperInfo) {
      billAddress = data.shipperInfo
      let fromIndex = 0
      let i = 1
      for (; i < 6; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = billAddress.substring(fromIndex)

      this.job.shipperCode = data.shipperCode

      this.shipperAddrChangeFunc(data.shipperInfo)
    }
    if (data.consigneeInfo) {
      billAddress = data.consigneeInfo
      let fromIndex = 0
      let i = 1
      for (; i < 5; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = billAddress.substring(fromIndex)
      this.job.consigneeCode = data.consigneeCode
      this.consigneeAddrChangeFunc(data.consigneeInfo)
    }
    if (data.notifyInfo) {
      billAddress = data.notifyInfo
      let fromIndex = 0
      let i = 1
      for (; i < 5; ++i) {
        const index = billAddress.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = billAddress.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = billAddress.substring(fromIndex)
      this.job.notifyCode = data.notifyCode
      this.notifyChangeFunc(data.notifyInfo)
    }
  }

  /**
   * 发货人选择
   */
  async shipperAutoCompleteChange(data) {
    const form = this.job
    form.shipperId = data.value
    if (!form.shipperId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.shipperLine1 = manifestAddress.addressLine1
      form.shipperLine2 = manifestAddress.addressLine2
      form.shipperLine3 = manifestAddress.addressLine3
      form.shipperLine4 = manifestAddress.addressLine4
      form.shipperLine5 = manifestAddress.addressLine5
      form.shipperLine6 = manifestAddress.addressLine6
      form.shipperLine7 = manifestAddress.addressLine7
    } else {
      form.shipperLine1 = ''
      form.shipperLine2 = ''
      form.shipperLine3 = ''
      form.shipperLine4 = ''
      form.shipperLine5 = ''
      form.shipperLine6 = ''
      form.shipperLine7 = ''
    }
    this.shipperAddrChangeFunc()
  }

  async shipperAddrChangeFunc() {
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.shipperCode = this.job.shipperCode
      hdoc.shipperLine1 = this.job.shipperLine1
      hdoc.shipperLine2 = this.job.shipperLine2
      hdoc.shipperLine3 = this.job.shipperLine3
      hdoc.shipperLine4 = this.job.shipperLine4
      hdoc.shipperLine5 = this.job.shipperLine5
      hdoc.shipperLine6 = this.job.shipperLine6
    }
  }

  async consigneeAutoCompleteChange(data) {
    const form = this.job
    form.consigneeId = data.value
    if (!form.consigneeId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.consigneeLine1 = manifestAddress.addressLine1
      form.consigneeLine2 = manifestAddress.addressLine2
      form.consigneeLine3 = manifestAddress.addressLine3
      form.consigneeLine4 = manifestAddress.addressLine4
      form.consigneeLine5 = manifestAddress.addressLine5
      form.consigneeLine6 = manifestAddress.addressLine6
      form.consigneeLine7 = manifestAddress.addressLine7
    } else {
      form.consigneeLine1 = ''
      form.consigneeLine2 = ''
      form.consigneeLine3 = ''
      form.consigneeLine4 = ''
      form.consigneeLine5 = ''
      form.consigneeLine6 = ''
      form.consigneeLine7 = ''
    }
    this.consigneeAddrChangeFunc()
  }
  /**
   * 收货人选择
   */
  async consigneeAddrChangeFunc() {
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.consigneeCode = this.job.consigneeCode
      hdoc.consigneeLine1 = this.job.consigneeLine1
      hdoc.consigneeLine2 = this.job.consigneeLine2
      hdoc.consigneeLine3 = this.job.consigneeLine3
      hdoc.consigneeLine4 = this.job.consigneeLine4
      hdoc.consigneeLine5 = this.job.consigneeLine5
      hdoc.consigneeLine6 = this.job.consigneeLine6
    }
  }
  /**
   * 通知人选择
   */
  async notifyAutoCompleteChange(data) {
    const form = this.job
    form.notifyId = data.value
    if (!form.notifyId) {
      return
    }
    const company = new Company(data)
    const manifestAddress = await company.getManifestAddress()
    if (manifestAddress) {
      form.notifyLine1 = manifestAddress.addressLine1
      form.notifyLine2 = manifestAddress.addressLine2
      form.notifyLine3 = manifestAddress.addressLine3
      form.notifyLine4 = manifestAddress.addressLine4
      form.notifyLine5 = manifestAddress.addressLine5
      form.notifyLine6 = manifestAddress.addressLine6
      form.notifyLine7 = manifestAddress.addressLine7
    } else {
      form.notifyLine1 = ''
      form.notifyLine2 = ''
      form.notifyLine3 = ''
      form.notifyLine4 = ''
      form.notifyLine5 = ''
      form.notifyLine6 = ''
      form.notifyLine7 = ''
    }
    this.notifyChangeFunc()
  }

  /**
   * 通知人选择
   */
  async notifyChangeFunc() {
    const hdoc = await new SeaImportJob(this.job).getMainHbl(true)
    if (hdoc) {
      hdoc.notifyCode = this.job.notifyCode
      hdoc.notifyLine1 = this.job.notifyLine1
      hdoc.notifyLine2 = this.job.notifyLine2
      hdoc.notifyLine3 = this.job.notifyLine3
      hdoc.notifyLine4 = this.job.notifyLine4
      hdoc.notifyLine5 = this.job.notifyLine5
      hdoc.notifyLine6 = this.job.notifyLine6
    }
  }

  /**
   * 收货人代码
   */
  qConsigneeCode_focusOutHandler() {
    if (!this.job.notifyCode) {
      this.job.notifyCode = this.job.consigneeCode
    }
  }

  /**
   * 收货人地址
   */
  qConsigneeAddr_focusOutHandler() {
    if (!this.job.notifyLine1) {
      this.job.notifyLine1 = this.job.consigneeLine1
    }
  }

  // 件数变化
  quantityFocusInHandler() {
    this.job.quantityContract = this.job.quantityActual
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }

  // 包装变化
  chargePacking() {
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
  }

  // 重量变化
  weightFocusInHandler() {
    this.calculateChargeWeight()
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }

  // 体积变化
  cubageFocusInHandler() {
    this.calculateChargeWeight()
    if (this.job.chargeWeight <= this.defaultChargeCubage) {
      this.job.chargeCubage = this.defaultChargeCubage
    }
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }
  // 计费重量变化
  chargeWeightChangeHandler() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }

  /**
   * @private
   * 计算计费重量
   */
  calculateChargeWeight() {
    const chargeWeight = this.job.weightContract / 1000 // 毛重或体积未填写时

    // 毛重或体积未填写时
    if (isNaN(this.job.cubageContract) && isNaN(this.job.weightContract)) {
      this.job.chargeWeight = 0
      return
    }
    if (isNaN(this.job.cubageContract)) {
      this.job.chargeWeight = chargeWeight
      return
    }
    if (isNaN(this.job.weightContract)) {
      this.job.chargeWeight = this.job.cubageContract
      return
    }

    if (chargeWeight > this.job.cubageContract) {
      this.job.chargeWeight = chargeWeight
    } else {
      this.job.chargeWeight = this.job.cubageContract
    }
  }

  /**
   * 整拼类型选择
   */
  qCargoType_Change(data) {
    const containerLoadType = data.value
    this.job.containerLoadType = containerLoadType
    if (containerLoadType === 'LCL') {
      /* 清空seaEQ */
      if (!this.job.delseaEQUuids) {
        this.job.delseaEQUuids = []
      }
      for (const item of this.job.seaEQ) {
        this.job.delseaEQUuids.push(item.uuid)
      }
      this.job.seaEQ.splice(0, this.job.seaEQ.length)
      /* 清空containers */
      if (!this.job.delContainerUuids) {
        this.job.delContainerUuids = []
      }
      for (const item of this.job.containers) {
        this.job.delContainerUuids.push(item.uuid)
      }
      this.job.containers.splice(0, this.job.containers.length)
      // 清空containerUsages
      this.job.containerUsages.splice(0, this.job.containerUsages.length)
    }
    this.job.masterFlag = containerLoadType === 'CON'

    // 改变自定义业务类型
    this.selectDefaultCutomJobType()

    // 判断客户是否有维护默认的主单运输条款
    const shippingTermList = getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
    if (shippingTermList && shippingTermList.length > 0) {
      for (const shippingTerm of shippingTermList) {
        let isFind = false
        const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
        if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
          for (const item of shippingTermOperationTypes) {
            if (item.containerLoadType === this.job.containerLoadType && item.mbl && item.lob === 'SI') {
              isFind = true
              break
            }
          }
        }
        if (isFind) {
          this.job.freightTermMBL = shippingTerm.code
          break
        }
      }
    }
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
    // 切换基本页签 handleTabClick
    this.view.$emit('containerLoadTypeEvent')
  }

  /**
   * @protected
   * 选择换单日期时锁定ETA ETD
   */
  dfCustDate_focusOutHandler() {
    if (this.job.transDate) {
      this.view.controllerEnable.dfETD = false
    } else {
      this.view.controllerEnable.dfETD = true
    }
  }

  /**
   * 投保
   */
  async toInsure() {
    let mblDoc = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === 'MBL') {
        mblDoc = doc
        break
      }
    }
    if (mblDoc == null) {
      return
    }
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: mblDoc.uuid,
      billno: this.job.mbl,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   let mblDoc = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === 'MBL') {
    //       mblDoc = doc
    //       break
    //     }
    //   }
    //   if (mblDoc == null) {
    //     return
    //   }
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: this.view.$store.getters.currentOfficeId,
    //     docUuid: mblDoc.uuid,
    //     billno: this.job.mbl,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // todo  前端埋点日志 LogStores.sendFunctionClickLogStoresByLabel('SI-基本-投保')
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let mbl = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === 'MBL') {
    //       mbl = doc
    //       break
    //     }
    //   }
    //   if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
    //     for (const usage of this.job.containerUsages) {
    //       delete usage.container
    //     }
    //   }
    //   if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
    //     for (const container of this.job.containers) {
    //       delete container.containerUsages
    //     }
    //   }
    //   SeaImCargoDoc.toInsure(this.user.tenantName, mbl, this.job, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
   * 投保成功
   */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }

  /**
   * 新增小票
   */
  async btnCreate_clickHandler() {
    const job = this.job
    if (!job.jobNo) {
      throw new ErrorTip(this.view.$t('Message.TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst'))
    }
    if (!await SecurityUtil.canOPEditWithAlert(job)) {
      return
    }
    this.view.ticketDialog.value = 1
    this.view.ticketDialog.visible = true
    // const lclJob = await new SeaImportJob(this.job).copyMasterJob()
    // lclJob.lclMasterUuid = this.job.uuid
    // lclJob.masterJobNo = this.job.jobNo
    // lclJob.lclMaster = this.job
    // lclJob.lclNumber = 1
    // this.view.$emit('addLcl', lclJob)
  }

  async toAddTicket() {
    this.view.ticketDialog.visible = false
    this.job.chargeWeight = 0
    const lclJob = await new SeaImportJob(this.job).copyMasterJob()
    lclJob.lclMasterUuid = this.job.uuid
    lclJob.lclMaster = this.job
    lclJob.lclNumber = this.view.ticketDialog.value
    this.view.$emit('addLcl', lclJob)
  }

  /**
   * 加入小票
   */
  btnAdd_clickHandler() {
    this.view.queryLclDialog.visible = true
  }

  /**
   * 加入小票 选择后处理
   */
  queryLclWindowReturnHandler(rows) {
    const jobKeys = Array.from(rows, p => p.uuid)

    // batchAddJob 后端实现 1.同步 jobKeys 的小票的 etd,vessel 等；2.重新合计主票中的件毛体以及计费重量; 3.进口刷新小票仓库信息
    batchAddJob(jobKeys, this.job.uuid, this.view.location).then(res => {
      if (res.data > 0) {
        for (const item of rows) {
          item.lclMasterUuid = this.job.uuid
          item.version = item.version + 1
          this.job.lclSlaves.push(item)
        }
        this.view.gridApi.setRowData(this.view.rowData)
        this.view.$emit('addSlavedJob', rows)

        this.refreshTotals()
        JobUtils.checkMasterShare(this.job.uuid)
      }
    })
  }
  /**
   * 移除小票
   */
  async btnRemove_clickHandler() {
    const selectedItems = [this.view.selectedRow]
    if (selectedItems.length === 0) {
      throw new ErrorTip('未选择小票', 'info')
    }
    if (!this.job) { return }

    await this.view.$confirm(this.view.$t('queryJob.AreWantToRemoveTicket'), this.view.$t('Message.Warning'), { type: 'warning' })

    for (const subJob of selectedItems) {
      await new SeaImportJob(subJob).getContainerUsages()

      if (subJob.quantityContract !== this.getItemLeft(subJob) || subJob.weightContract !== this.getWeightLeft(subJob) ||
        subJob.cubageContract !== this.getCubageLeft(subJob)) {
        throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      }

      for (const c of subJob.containerUsages) {
        if (c.container && c.container.jobUuid && c.container.jobUuid === this.job.uuid) {
          throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        }
      }
    }
    const jobKeys = Array.from(selectedItems, p => p.uuid)
    await checkJobForShared(jobKeys).then(res => {
      if (res.data) {
        this.view.$message.warning(res.data + this.view.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
      } else {
        batchRemoveJob(jobKeys, this.view.location).then(res => {
          this.delResultHandler(res.data, jobKeys)
        })
        this.view.selectedRowIndex = null
      }
    })
  }

  async delResultHandler(num, jobKeys) {
    if (num > 0) {
      // 更新主票上的 件重尺
      syncLclSlaveMasterJob({ jobUuid: this.job.uuid })

      this.job.lclSlaves = ''
      const lclSalves = await new SeaImportJob(this.job).getLclSlaves()
      this.job.lclSlaves = []
      if (lclSalves) { this.job.lclSlaves.push(...lclSalves) }
      this.view.gridApi.setRowData(this.job.lclSlaves)

      this.refreshTotals()

      this.view.$emit('removeJobFromMaster', jobKeys)
    }
  }

  onBatchPrint() {
    const selectedItems = this.view.gridApi.getSelectedRows()
    if (selectedItems.length === 0) {
      throw new ErrorTip(this.view.$t('queryJob.NoBusinessSelected'), 'info')
    }

    this.view.templateSelectorDialog.ctx = new SeaImportJob(this.job)
    this.view.templateSelectorDialog.category = 'JOBLIST'
    this.view.templateSelectorDialog.data = { JOB_UUID: Array.from(selectedItems, p => p.uuid) }
    this.view.templateSelectorDialog.visible = true
  }

  getItemLeft(input) {
    let quantity = input.quantityContract
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return quantity
  }
  getWeightLeft(input) {
    let weight = input.weightContract
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return weight
  }
  getCubageLeft(input) {
    let cubage = input.cubageContract
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return cubage
  }
  // 加载仓库航线关联信息,并初始化仓库下拉框数据
  async loadWarehouseRegion(updateWarehousing = false) {
    const job = this.job
    job.warehouseList = []
    this.view.warehouseList = []
    if (this.companyList && this.companyList.length > 0) {
      this.view.warehouseList = this.companyList.filter(item => { return item.warehouse && item.active })
    }
    if (parseInt(this.config.get('AssociatedRoute')) !== 1 || !job.dischargingPortCode || !this.companyList || this.companyList.length === 0) return
    const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
    if (port) {
      const region = this.regionList.find(p => p.code === port.region)
      if (region && region.warehouseRegions && region.warehouseRegions.length > 0) {
        this.view.warehouseList = []
        if (region.warehouseRegions.length === 1) {
          const warehouse = this.companyList.find(p => p.uuid === region.warehouseRegions[0].companyUuid)
          if (warehouse) {
            this.view.warehouseList.push(warehouse)
            if (updateWarehousing) { // 新增
              this.warehouseCmpChangeHandler({ value: warehouse.cmpIdx })
            }
          }
        } else {
          for (const warehouseRegion of region.warehouseRegions) {
            const warehouse = this.companyList.find(p => p.uuid === warehouseRegion.companyUuid)
            if (warehouse) {
              if (this.view.warehouseList.findIndex(p => p.uuid === warehouse.uuid) < 0) {
                this.view.warehouseList.push(warehouse)
              }
            }
          }
          if (updateWarehousing && job.warehousing) {
            if (this.view.warehouseList.length > 0) {
              if (job.warehouseCmp && job.warehouseCmp > 0) { // 判断现在的仓库是否在新的仓库下拉框之内
                const w = this.view.warehouseList.find(p => p.cmpIdx === job.warehouseCmp)
                if (!w) {
                  const defaultWarehouse = this.view.warehouseList.find(p => p.defaultWarehouse)
                  if (defaultWarehouse) {
                    await this.warehouseCmpChangeHandler({ value: defaultWarehouse.cmpIdx })
                  } else {
                    await this.warehouseCmpChangeHandler({ value: 0 })
                  }
                }
              } else { // 取默认仓库，没有则清空
                const defaultWarehouse = this.view.warehouseList.find(p => p.defaultWarehouse)
                if (defaultWarehouse) {
                  await this.warehouseCmpChangeHandler({ value: defaultWarehouse.cmpIdx })
                } else {
                  await this.warehouseCmpChangeHandler({ value: 0 })
                }
              }
            }
          }
        }
        job.warehouseList = this.view.warehouseList
      }
    }
  }

  //    英文品名变化
  async txtCargoEnglishNameChangeHandler() {
    if (!this.view.isEdit) return
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }

  /**
   * 报关行
   */
  customsBrokerChangeHandler(data) {
    const job = this.job
    // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.customsBroker = data.value
    this.view.context.reloadCharge = true
  }
}
